export class FormHealthSystemRequest {
  name: string = ""
  email: string = ""
  website: string = ""
  street_address: string = ""

  organization_id: string = ""
  organization_name: string = ""
  api_mode: string =  "test"
}
